'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/BackOffice'

import DatePicker from '@/Form/V2/DatePicker'

let app = window.app;

const moment = window.moment;

export default class OrdersByThemeExportPage extends Component
{
	state =
	{
		form_data:
		{
			start: moment().startOf('month').format('YYYY-MM-DD'),
			end: moment().endOf('month').format('YYYY-MM-DD')
		},

		status_messages: { }
	};

	handleDateChange = ({ e, value, name }) =>
	{
		const component = this, props = this.props, state = this.state;

		delete state.status_messages[name];

		state.form_data[name] = value;

		component.setState(
		{
			form_data: state.form_data,
			status_messages: state.status_messages
		});
	}

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const { start, end } = state.form_data;

		var output =
		(
			<Layout history={ props.history }
				page_title="Export des commandes par thème">

				<div className="page-content">

					<div className="o-grid-2">

						<div className="o-grid__item u-flex u-items-start u-gap-15">
							<DatePicker name="start" label="Du" inline
								onChange={ component.handleDateChange }
								value={ state.form_data.start }
							/>

							<DatePicker name="end" label="Au" inline
								onChange={ component.handleDateChange }
								value={ state.form_data.end }
							/>
						</div>

					</div>

					<div className="o-content u-margin-top-20">

						<a className="c-btn c-btn--extra"
							href={ '/export/toutes-les-commandes-par-theme?debut=' + start
							+ '&fin=' + end } target="_blank" rel="noreferrer">
							Télécharger
						</a>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}